import { CatContextualMenu } from '@blocks-react/components/ContextualMenu';
import { ReactElement } from 'react';

export type EquipmentMoreActionProps = {
  children?: ReactElement;
};

export const EquipmentMoreAction = ({ children }: EquipmentMoreActionProps) => {
  return (
    <CatContextualMenu position="auto">{children}</CatContextualMenu>
  );
};
